
  export default {
    mounted() {
      const vatNumberInput = this.el.querySelector("#vat-number-input");

      this.el.querySelector("#form_company").addEventListener("blur", event => {
        if (!event.target.value?.trim()) {
          vatNumberInput.removeAttribute("required");
        } else {
          vatNumberInput.setAttribute("required", "true"); 
        } 
      });
    }
  }
